const WEB_INTERCEPT_SCRIPT_ID = 'bri-web-intercept-survey-loader';
const BRI_VISITOR_ID_KEY = 'briVisitorID';
const WEB_INTERCEPT_BASE_URL = 'https://x9igtv25r3.execute-api.us-east-1.amazonaws.com/prod/surveywebintercept/start/client/b63ccc63f53d4eeb9890b43530b695fe';
function getOrCreateVisitorId() {
    try {
        const existingVisitorId = window.localStorage?.getItem(BRI_VISITOR_ID_KEY);
        if (existingVisitorId) {
            return existingVisitorId;
        }
        const generatedVisitorId = window.crypto?.randomUUID?.().replace(/-/g, '') ?? '';
        if (generatedVisitorId) {
            window.localStorage?.setItem(BRI_VISITOR_ID_KEY, generatedVisitorId);
        }
        return generatedVisitorId;
    }
    catch {
        return '';
    }
}
function buildSurveyUrl() {
    const params = new URLSearchParams({
        title: document.title,
        v: getOrCreateVisitorId(),
        v1: document.location.host,
        v2: document.location.hash,
        v3: document.location.href,
        v4: window.screen.width.toString(),
        v5: window.screen.height.toString(),
        v6: new Date().getTimezoneOffset().toString(),
        v7: '',
        v8: '',
        v9: '',
        v10: '',
    });
    return `${WEB_INTERCEPT_BASE_URL}?${params.toString()}`;
}
function shouldEnableWebIntercept(environment) {
    const normalizedEnvironment = environment?.toLowerCase();
    return normalizedEnvironment !== 'dev' &&
        normalizedEnvironment !== 'development' &&
        normalizedEnvironment !== 'local' &&
        normalizedEnvironment !== 'test'
        ? true
        : false;
}
export function initWebInterceptSurvey(environment) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }
    if (!shouldEnableWebIntercept(environment)) {
        return;
    }
    if (document.getElementById(WEB_INTERCEPT_SCRIPT_ID)) {
        return;
    }
    const script = document.createElement('script');
    script.id = WEB_INTERCEPT_SCRIPT_ID;
    script.src = buildSurveyUrl();
    script.defer = true;
    document.head.appendChild(script);
}
//# sourceMappingURL=webInterceptSurvey.js.map